module.exports = __webpack_public_path__ + "static/app-download-android-cn-9def2a04c5614d57cf08a2890fffdba4.png";